<template>
    <div style="padding:15px;">
            <div style="border-bottom:1px solid #eaeaea;">
                <h1 style="margin-top:0px; text-align:center;">{{notice.title}}</h1>
                <p style="text-align:right;">{{notice.created_at}}</p>
            </div>
            <p>{{notice.detail}}</p>
    </div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: "Notice",
        data(){
            return {
                notice: '',
            };
        },
        created() {
            let url = window.location.href ; //获取url中"?"符后的字串
            let company_id = url.split('?id=')[1];
            api.request('/notice/detail', {
                id : company_id,
            }).then(res => {
                this.notice =res.data;
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/common/Notice.vue